import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { AppConfig } from '../../AppConfig';
import { AppTheme, AppStyles } from '../../styles/AppTheme';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { CommonStyles } from '../../styles/Styles';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import { ImageComponent } from '../../components/quizzing/ImageComponent';

export class RadioComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value ? this.props.value : 0 //TODO: why zero?
    }
  }

  change = e => {
    // this.setState({
    //   [e.target.name]: e.target.value
    // });
    if (e.target.value === this.state.value) {
      this.setState({
        value: null
      })
      this.props.handleState(e.target.name, null)
    } else {
      this.setState({
        value: e.target.value
      })
      this.props.handleState(e.target.name, e.target.value)
    }

    // for(const item  of Object.keys(this.props.data.options)) {
    //   if(this.props.data.options[item].title === e.target.value) {
    //     this.props.handleState(this.props.data.id, this.props.data.options[item].id)
    //     break;
    //   }
    // }
  }

  render() {
    const thisObj = this //TODO
    return (
      <div className={css(CommonStyles.outerContainer)}>
        <div>
          {this.props.mainTitle &&
            <div className={css(CommonStyles.questionMainTitleContainer)}>
              <p className={css(CommonStyles.questionMainTitle)}>{this.props.mainTitle}</p>
              {this.props.showInformationPopup &&
                <div className={css(CommonStyles.questionDetailContainer)} onClick={() => this.props.showInformationPopup(this.props.data)}>
                  <p className={css(CommonStyles.questionDetailContent)}>i</p>
                </div>
              }
            </div>
          }
          {this.props.data.subTitle &&
            <p className={css(CommonStyles.questionSubTitle)}>{this.props.data.subTitle}</p>
          }
        </div>
        {this.props.data.image &&
          <div className={css(CommonStyles.outerImageContainer)}>
            <ImageComponent data={this.props.data} />
          </div>
        }
        <div className={css(this.props.survey ? Styles.innerContainer : CommonStyles.innerContainer)}>
          <RadioGroup
            name={this.props.data.id}
            value={this.state.value}
            // onChange={e => this.change(e)}
            className={css(Styles.radioGroup)}>
            <Grid container spacing={3}
              className={this.props.type === 'YESNO' ? css(Styles.outerMainContainer) : css(Styles.outerMainContainerRadio)}>
              {Object.keys(this.props.data.options).sort(function (a, b) { return (Number(thisObj.props.data.options[a].order) - Number(thisObj.props.data.options[b].order)) })
                .map(item => {
                  return (
                    <Grid item xs={12} sm={12} md={this.props.survey ? 6 : 12} lg={this.props.survey ? 6 : 12} className={css(Styles.outerContainer)} key={item}>
                      <FormControlLabel
                        value={String(this.props.data.options[item].id)}
                        control={
                          <Radio
                            onClick={e => this.change(e)}
                            color='secondary'
                            checkedIcon={
                              <div className={css(Styles.icon)}>
                                <div className={css(Styles.checkedIcon)} />
                              </div>
                            }
                            icon={
                              <div className={css(Styles.icon)} />
                            }
                            className={css(CommonStyles.controlLabel)}
                          />}
                        label={this.props.data.options[item].title}
                        key={this.props.data.options[item].id}
                        classes={{
                          label: this.props.survey ? css(CommonStyles.formLabel, Styles.customPadding) : css(CommonStyles.formLabel, Styles.nonSurvey)
                        }}
                        className={css(CommonStyles.innerSelection)}
                      />
                    </Grid>
                  )
                })}
            </Grid>
          </RadioGroup>
        </div>
      </div>
    );
  }
}

const Styles = StyleSheet.create({
  radioGroup: {
    width: '100%',
  },
  outerMainContainerRadio: {
    width: '100%',
    '@media (max-width: 767px)': {
      margin: 0,
    }
  },
  outerMainContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
    '@media (max-width: 767px)': {
      margin: 0,
    }
  },
  outerContainer: {
    '@media (max-width: 767px)': {
      padding: 5,
    }
  },
  icon: {
    width: 25,
    height: 25,
    background: AppTheme.secondaryBg + '0% 0% no-repeat padding-box',
    border: '3px solid' + AppTheme.borderColor,
    zIndex: 0,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  checkedIcon: {
    width: 19,
    height: 19,
    borderRadius: '50%',
    backgroundColor: AppTheme.selectedColor
  },
  innerContainer: {
    marginTop: 10,
    marginLeft: 20,
    '@media (max-width: 767px)': {
      marginLeft: 10,
    }
  },
  customPadding: {
    paddingTop: 10,
  },
  nonSurvey: {
    paddingTop: 10,
    textAlign: 'left'
  }
})


// WEBPACK FOOTER //
// ./src/components/quizzing/RadioComponent.js